var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c("div", { staticClass: "contents_wrap" }, [
      _c("h2", { staticClass: "pg_title" }, [_vm._v("Mobile Authorization")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "box_wrap" }, [
        _vm.loginYN === "Y"
          ? _c(
              "div",
              { staticStyle: { "text-align": "center", width: "100%" } },
              [
                _c("otp"),
                _vm._v(" "),
                _c(
                  "h4",
                  {
                    staticStyle: {
                      "font-size": "1.2em",
                      "margin-bottom": "8px",
                      "margin-top": "16px"
                    }
                  },
                  [_vm._v("Browser Plugin")]
                ),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("table", { staticClass: "data_table_ty2" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _vm._m(3),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _c("td", { staticClass: "text_left" }, [
                        _vm._v("Online (Web Store Download)")
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text_left" }, [
                        _c("a", { attrs: { href: _vm.STORE_CHROME } }, [
                          _vm._v("Chrome Store "),
                          _c("img", {
                            attrs: {
                              src: "/static/images/ico_attach.png",
                              alt: ""
                            }
                          })
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "text_left" }, [
                        _c(
                          "div",
                          { staticClass: "accordion_wrap toggle_close" },
                          [
                            _c("header", { on: { click: _vm.clickToggle } }, [
                              _vm._v("Offline (SKP Download)"),
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v(
                                  "   * Note: Please use this SKP local downloading only when plug-in is not downloaded online."
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm._m(4)
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm._m(5)
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "h4",
                  {
                    staticStyle: {
                      "font-size": "1.2em",
                      "margin-bottom": "8px",
                      "margin-top": "16px"
                    }
                  },
                  [_vm._v("NASCA Client")]
                ),
                _vm._v(" "),
                _vm._m(6)
              ],
              1
            )
          : _c("div", { staticClass: "login_wrap" }, [
              _vm.pinYN === "T"
                ? _c("div", { staticClass: "item_login loginD" }, [
                    _c("div", [
                      _vm._v("You first need to obtain an access to Mobile.")
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.pinYN === "Y" && _vm.loginYN !== "Y"
                ? _c("div", { staticClass: "item_login loginT" }, [
                    _c("ul", { staticClass: "w100" }, [
                      _c("li", { staticClass: "sub_tit" }, [
                        _vm._v("Certificates Password")
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "mt20" }, [
                        _c("span", { staticClass: "clearable" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.certPwd,
                                expression: "certPwd"
                              },
                              { name: "validation", rawName: "v-validation" },
                              { name: "clearable", rawName: "v-clearable" }
                            ],
                            staticClass: "text_input w100",
                            attrs: {
                              type: "password",
                              placeholder: "",
                              minlength: "4",
                              maxlength: "24",
                              value: ""
                            },
                            domProps: { value: _vm.certPwd },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.doLogin()
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.certPwd = $event.target.value
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            staticClass: "btn_blue w100 h40 mt10",
                            attrs: { href: "javascript:", title: "" },
                            on: {
                              click: function($event) {
                                return _vm.doLogin()
                              }
                            }
                          },
                          [_vm._v("Login")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("ul", { staticClass: "login_L_txt" }, [
                      _vm.loginLockYN === "Y" || _vm.monthLockYN === "Y"
                        ? _c("li", [
                            _vm._v(
                              "\n                                If your account is locked, request an unlock\n                            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.loginLockYN === "Y" || _vm.monthLockYN === "Y"
                        ? _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "txt_link",
                                  attrs: {
                                    to:
                                      "/basis/anysvcmobile/request/RequestOther"
                                  }
                                },
                                [_vm._v("Other Request")]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._m(7),
                      _vm._v(" "),
                      _c("li", [_vm._v(" ")]),
                      _vm._v(" "),
                      _vm._m(8)
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.loginYN === "Y"
                ? _c(
                    "div",
                    {
                      staticClass: "item_login loginT",
                      staticStyle: {
                        height: "100px",
                        "line-height": "80px",
                        "font-size": "1.5em"
                      }
                    },
                    [
                      _vm._v(
                        "\n                        You are already logged in.\n                    "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pinYN === "N" && _vm.monthLockYN !== "Y"
                ? _c("div", { staticClass: "item_login" }, [_vm._m(9)])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "item_login" }, [
                _c("ul", { staticClass: "login_R_txt" }, [
                  _c("li", [
                    _vm._v(
                      '1. If you have not registered or have changed the working PC, click the "Access Request" button below.'
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn_sm_white",
                          attrs: {
                            to: "/basis/anysvcmobile/request/RequestCert"
                          }
                        },
                        [_vm._v("Access Request")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "2. After the approval, you will receive an email with a PIN."
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "3. You can redeem a certificate using the PIN for secure login to Anysvc."
                    )
                  ]),
                  _vm._v(" "),
                  _vm.pinYN === "N"
                    ? _c("li", { staticClass: "issue_go" }, [
                        _c(
                          "a",
                          {
                            staticClass: "btn_sm_white",
                            attrs: {
                              href: "javascript:",
                              id: "show-modal",
                              title: ""
                            },
                            on: { click: _vm.showCertificateIssuePopup }
                          },
                          [_vm._v("Redeem Certificate")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "4. The certificate is dedicated to the issued computer. If you change the computer, you must get the certificate reissued."
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [_vm._v("5. Login with password")])
                ])
              ])
            ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bc_ico" }, [
      _vm._v("\n                Home\n                "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v("Engineer\n                "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v(" Mobile SVC\n                "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v("Mobile Authorization\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { position: "relative" } }, [
      _c(
        "span",
        {
          staticStyle: {
            display: "block",
            position: "absolute",
            top: "-24px",
            right: "110px"
          }
        },
        [
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href: "/static/setup/MobileSVC_Installation_Guide.pdf"
              }
            },
            [
              _vm._v("Mobile SVC Installation Guide "),
              _c("img", {
                attrs: { src: "/static/images/ico_attach.png", alt: "" }
              })
            ]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "70%" } }),
      _vm._v(" "),
      _c("col")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text_center" }, [_vm._v("Type")]),
        _vm._v(" "),
        _c("th", { staticClass: "text_center" }, [_vm._v("Download")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "ul_list" }, [
      _c("br"),
      _vm._v(
        "※If you install an extension through manual installation, it is disabled so that you cannot delete the extension.\n\t\t\t                                "
      ),
      _c("br"),
      _vm._v(
        "　(It can be deleted when installed in the web store)\n\t\t\t                                "
      ),
      _c("br"),
      _vm._v(
        "　It is recommended to install an extension program in the web store, and if you cannot access the web store, please use it.\n\t\t\t                                "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n\t\t\t                                □ Manual installation method:"
      ),
      _c("br"),
      _vm._v(
        "\n\t\t\t\t\t\t\t\t\t\t\t1. Please unzip the attached file to the path below."
      ),
      _c("br"),
      _vm._v(
        "\n\t\t\t\t\t\t\t\t\t\t\t- Target file: crx.crx /jnobgabnnbdhjompaagbfbjiimplamll.xml /reg_Chrome.reg / reg_Edge.reg"
      ),
      _c("br"),
      _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t- Path: C:\\Windows\\pcdrm\\dump"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t2. Reg file execution"),
      _c("br"),
      _vm._v(
        "\n\t\t\t\t\t\t\t\t\t\t\t- reg_Chrome.reg(Chrome extension program added)"
      ),
      _c("br"),
      _vm._v(
        "\n\t\t\t\t\t\t\t\t\t\t\t- reg_Edge.reg(Add edge extension program)"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n\t\t\t\t\t\t\t\t\t\t\t3. After about 30 seconds, enter the path below in the address input line to check for extended installation"
      ),
      _c("br"),
      _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t- Chrome chrome://extensions"),
      _c("br"),
      _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t- Edge edge://extensions/"),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "text_left" }, [
      _c("a", { attrs: { href: "/static/setup/drm-offline.zip" } }, [
        _vm._v("Offline    "),
        _c("img", { attrs: { src: "/static/images/ico_attach.png", alt: "" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("table", { staticClass: "data_table_ty2" }, [
      _c("colgroup", [
        _c("col", { attrs: { width: "70%" } }),
        _vm._v(" "),
        _c("col")
      ]),
      _vm._v(" "),
      _c("thead", [
        _c("tr", [
          _c("th", { staticClass: "text_center" }, [_vm._v("Type")]),
          _vm._v(" "),
          _c("th", { staticClass: "text_center" }, [_vm._v("Download")])
        ])
      ]),
      _vm._v(" "),
      _c("tbody", [
        _c("tr", [
          _c("td", { staticClass: "text_left" }, [_vm._v("NASCA Client")]),
          _vm._v(" "),
          _c("td", { staticClass: "text_left" }, [
            _c(
              "a",
              { attrs: { href: "/static/setup/NASCA_SD_5.00_32bit.exe" } },
              [
                _vm._v("NASCA 32Bit OS "),
                _c("img", {
                  attrs: { src: "/static/images/ico_attach.png", alt: "" }
                })
              ]
            ),
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              { attrs: { href: "/static/setup/NASCA_SD_5.00_64bit.exe" } },
              [
                _vm._v("NASCA 64Bit OS "),
                _c("img", {
                  attrs: { src: "/static/images/ico_attach.png", alt: "" }
                })
              ]
            ),
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              { attrs: { href: "/static/setup/NSD_5.00_2022070420.exe" } },
              [
                _vm._v("Non-NASCA 32/64Bit OS "),
                _c("img", {
                  attrs: { src: "/static/images/ico_attach.png", alt: "" }
                })
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href: "/static/setup/TrustNet_Cert_WEBCLIENT_v1.0.0.9.exe"
          }
        },
        [
          _vm._v("PC Certificate (TrustNet Web Client) "),
          _c("img", {
            attrs: { src: "/static/images/ico_attach.png", alt: "" }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href: "/static/setup/MobileSVC_Installation_Guide.pdf"
          }
        },
        [
          _vm._v("Mobile SVC Installation Guide "),
          _c("img", {
            attrs: { src: "/static/images/ico_attach.png", alt: "" }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n                            Your Access to HHP has been approved but you have not redeemed a certificate yet.\n                            "
      ),
      _c("br"),
      _vm._v(
        'Please get a certificate first by using the "Redeem Certificate" button on the right.\n                        '
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e7027cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e7027cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/certificate/CertLogin.vue
// module id = YP+u
// module chunks = 0